module.exports = __webpack_public_path__ + "static/media/bottomImage.3f538ef5.svg";